import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  OrdersFolderCancelDialogComponent,
  OrdersFolderPaymentsDialogComponent,
  OrdersPaymentsEditDialogComponent,
} from '@app/orders/components/utils';
import { OrdersPrintDialogComponent } from '@app/orders/components/utils/orders-print-dialog/orders-print-dialog.component';

@Component({
  selector: 'app-orders-dialogs-host',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    OrdersFolderPaymentsDialogComponent,
    OrdersFolderCancelDialogComponent,
    OrdersPaymentsEditDialogComponent,
    OrdersPrintDialogComponent,
  ],
  template: `
    <app-orders-folder-payments-dialog></app-orders-folder-payments-dialog>
    <app-orders-folder-cancel-dialog></app-orders-folder-cancel-dialog>
    <app-orders-payments-edit-dialog></app-orders-payments-edit-dialog>
    <app-orders-print-dialog></app-orders-print-dialog>
  `,
})
export class OrdersDialogsHostComponent {}
